import styled from 'styled-components';

export const Container = styled.div`
  height:90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2em 2em 1em 2em;
`

export const ContentContainer = styled.div`
  height:100%;
  width: 100%;
  max-width: 1200px;
  flex: 1;
`
